import {
  type CourierType,
  STATUS_COURIER,
} from '@/domains/mobile-web/constant/listStatusCourier.constant';
import { useColorStore } from '@/store/colorStore';

interface BadgeCourierProps {
  statusCourier: CourierType;
  /** Overrides the constant's label, e.g. with the API's status label */
  label?: string | null;
}

const BadgeCourier = ({ statusCourier, label }: BadgeCourierProps) => {
  const { NEWCOLOR } = useColorStore();
  const currentStatus = STATUS_COURIER[statusCourier];

  return (
    <div
      className="px-3 py-1 rounded-[4px] w-fit h-fit"
      style={{ backgroundColor: NEWCOLOR[currentStatus.bg], color: currentStatus.color }}
    >
      {label ?? currentStatus.label}
    </div>
  );
};

export default BadgeCourier;
